import { createSlice } from '@reduxjs/toolkit';

const defaultAIConfig = {
  enabled: false,
  supported_tools: [],
};

const configurationSlice = createSlice({
  name: 'configuration',
  initialState: {
    data: null,
    ai_download_enabled: defaultAIConfig,
    ai_share_enabled: defaultAIConfig,
  },
  reducers: {
    setConfiguration: (state, action) => {
      state.data = action.payload;
    },
    setAIConfig: (state, action) => {
      state.ai_download_enabled =
        action.payload.ai_download_enabled ?? defaultAIConfig;

      state.ai_share_enabled =
        action.payload.ai_share_enabled ?? defaultAIConfig;
    },
  },
});

export const {
  setConfiguration,
  setAIConfig,
} = configurationSlice.actions;

export default configurationSlice.reducer;